
export function HorizontalGrid({ children, center = false, gap = 0 }) {
    const columnStyle = (i) => ({
        display: "inline-block",
        width: 100/children.length + "%",
        padding: `0px ${gap/2}px`,
        boxSizing: "border-box"
    });

    return <div style={center ? { textAlign: "center" } : {}}>
        {children.map((child, i) => <div style={columnStyle(i)} key={i}>{child}</div>)}
    </div>;
}

export function Blocker({ active = false, children }) {
    return <div className={"blocker" + (active ? " active" : "")}>{children}</div>
}